
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import config from "../../../Helpers/config.json";
import { errorMessages } from "../../../Helpers/ErrorMessages";
import { history } from "../../../Helpers/history";
import { useReusableNewWholeSales } from "./useReusableNewWholeSales";
import { validateCurrentDate } from "../../../Utils/ConvertDate";

const paymentMethods = [
  { label: "MTN" },
  { label: "Airtel" },
  { label: "Cash" },
  // { label: "VISA" },
  { label: "Bank" },
];

export const useNewWholeSaleReceipt = (actions, invoice_number = "", saletype = "") => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const singleUser = user || {};
  const user_id = singleUser.user_id || 1;

  const [submitted, setSubmitted] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [invoice_id, setInvoiceId] = useState("");
  const [isSubmitted, setIsSubmitted] = useState("idle");
  const [payTypes, setPayTypes] = useState([]);
  // const [paytype, setPaytype] = useState(""); // instead of undefined or pre-set

  const [receipt_no, SetReceipt_no] = useState("");
  const [receiptData, setReceiptData] = useState({
    products: [],
    customer: {},
    loading: "idle",
  });

  // const permissions = singleUser.permission || {};
  // const approval_status = permissions.approval_status || {};

  const { stateFunctions, stateVariables } = useReusableNewWholeSales(
    actions,
    invoice_number,
    true,
    saletype
  );

  const {
    customer,
    rows,
    customerDetails,
    totals,
    initialState,
    state,
    paytype,
  } = stateVariables;

  const { setRows, setCustomer, setTotals, setCustomerDetails, setIsBlocking } = stateFunctions;

  const { customer_id } = customer;
  const isMounted = useRef(true);

  // useEffect(() => {
  //   setCustomer({ customer_name: "Walk-in Customer", customer_id: 1 });
  // }, []);
  useEffect(() => {
    // only reset to Walk-in if retail cash
    if (saletype === "retail" ) {
      setCustomer({ customer_name: "Walk-in Customer", customer_id: "1" });
    }
  }, [saletype]);
  
  // useEffect(() => {
  //   isMounted.current = true;
  //   try {
  //     const arr = paymentMethods
  //       .map((item, index) => ({ value: index + 1, text: item.label }))
  //       .filter((item) => item.text !== "CREDIT");
  //     setPayTypes(arr);
  //   } catch (error) {
  //     errorMessages(error, null, actions);
  //   }
  //   return () => { isMounted.current = false };
  // }, []);

  useEffect(() => {
    isMounted.current = true;
  
    try {
      if (!Array.isArray(paymentMethods)) return;
  
      const cashMethods = paymentMethods
        .map((item, index) => ({ value: index + 1, text: item.label }))
        // .filter((item) => item.text.toUpperCase() === "CASH"); // Only include CASH
  
      if (isMounted.current) setPayTypes(cashMethods);
    } catch (error) {
      errorMessages(error, null, actions);
    }
  
    return () => {
      isMounted.current = false;
    };
  }, [paymentMethods, actions]);
  

  const handleCloseDialog = () => setOpenDialog(false);

  const retrieveReceiptDetails = (item) => {
    const { receipt_number: recep_number, customer_id: cus_id } = item;
    const formData = new FormData();
    formData.append("receipt_number", recep_number);
    formData.append("invoice_number", "");
    formData.append("customer_id", cus_id);

    if (isMounted.current) setReceiptData({ ...receiptData, loading: "loading" });

    axios.post(`${config.epharmUrl}/Cinvoice/view_receipt`, formData)
      .then((response) => {
        if (!isMounted.current) return;
        const dt = response.data || {};
        const arr = dt.bill || [];
        const customer_details = dt.customer_details || {};
        const obj = arr[0] || {};
        setReceiptData({
          products: arr,
          customer: { ...customer_details, ...obj },
          loading: "success",
        });
        setOpenDialog(true);
      })
      .catch((error) => {
        if (!isMounted.current) return;
        errorMessages(error, null, actions);
        setReceiptData({ ...receiptData, loading: "error" });
      });
  };

  const handleSaveReceipt = (event) => {
    event.preventDefault();
    const { paid_amount, n_total, due_amount, change } = totals;
    const { credit_limit } = customerDetails;
    const { customer_id } = customer;
    const { invoice_date } = state;

    setSubmitted(true);
    const allRowsValid = rows.every(item => item.batch_id && item.product_name && item.product_quantity && !item.isDiscountable);
    const validate_invoice_date = validateCurrentDate(invoice_date);

    if (!(allRowsValid && paid_amount && paytype && paid_amount >= n_total )) return;

    setIsSubmitted("pending");
    setIsBlocking(false);

    if (rows.some(item => item.isError)) {
      actions.snackbarActions.errorSnackbar("Cannot save receipt: some product prices are lower than the original.");
      return;
    }

    if (!(due_amount <= credit_limit || credit_limit === 0)) {
      actions.snackbarActions.infoSnackbar({
        message: `The customer has reached their credit limit of ${credit_limit.toLocaleString()}. Please clear the balance before purchasing more items`,
        duration: 10000
      });
      return;
    }

    const data = rows.map(row => ({
      ...row,
      product_id: row.product_id,
      batch_id: row.batch_id,
      quantity: row.product_quantity,
      rate: row.product_rate,
      id: row.related_product,
      discount: row.discount ?? 0,
      discount_rate: row.discount_rate ?? 0,
      discount_amount: row.discount_amount ?? 0,
      batch_details_id: row.batch_details_id ?? null,
    }));

    const amount_paid = paid_amount > n_total ? n_total : paid_amount;

    axios.post(
      `${config.epharmUrl}/Cinvoice/insert_invoice`,
      {
        payment_type: 1,
        payment_method: +paytype,
        customer_id,
        total_amount: n_total,
        amount_paid,
        bill_details: data,
        invoice_date,
        balance: change,
        is_wholesale: saletype === "wholesale",
      },
      { headers: { user_id } }
    ).then(response => {
      if (!isMounted.current) return;
      const dt = response.data?.data || {};
      const recep = dt[0]?.receipt || {};
      const recep_id = recep?.receipt_no || "";
      const cus_id = dt[0]?.customer_id || "";
      retrieveReceiptDetails({ receipt_number: recep_id, customer_id: cus_id });
      actions.snackbarActions.successSnackbar("Receipt saved successfully!");
      setIsSubmitted("resolved");
      setSubmitted(false);
      setRows(initialState);
      // setCustomer({ customer_name: "Walk-in Customer", customer_id: cus_id });
      if (saletype === "retail" ) {
        setCustomer({ customer_name: "Walk-in Customer", customer_id: "1" });
      } else {
        // keep existing customer
        setCustomer(customer); // or just skip this line
      }
      
      setTotals({
        grand_total_price: 0,
        n_total: 0,
        change: 0,
        due_amount: 0,
        paid_amount: "",
        previous_amount: 0,
        total_discount_amount: 0
      });
      setCustomerDetails({ credit_limit: 0 });
      setInvoiceId(recep_id);
      SetReceipt_no(recep_id);
    }).catch(error => {
      if (!isMounted.current) return;
      errorMessages(error, null, actions);
      setIsSubmitted("rejected");
    });
  };




  const handleCashierSaveReceipt = (event) => {
    if (event) event.preventDefault();
    setSubmitted(true);

    const { paid_amount, n_total, change } = totals;
    const { customer_id } = customer;
    const { invoice_date } = state;

    if (!rows.every(item => item.batch_details_id && item.product_name && item.product_quantity)) {
      actions.snackbarActions.infoSnackbar({ message: "Please ensure all products have batch, name, quantity", duration: 5000 });
      setSubmitted(false);
      return;
    }
    if(paid_amount<n_total){
      actions.snackbarActions.infoSnackbar({ message: "Please Pay All The Total Bill  ", duration: 5000 });
      setSubmitted(false);
      return;

    }
    const validation = validateInvoice({ rows, customer_id, invoice_date: state.invoice_date, totals });

    if (!validation.valid) {
      actions.snackbarActions.infoSnackbar({ message: validation.message, duration: 5000 });
      setSubmitted(false);
      return;
    }

    // if (!validateCurrentDate(invoice_date)) {
    //   actions.snackbarActions.infoSnackbar({ message: "Please select a valid invoice date", duration: 5000 });
    //   setSubmitted(false);
    //   return;
    // }

    if (!customer_id) {
      actions.snackbarActions.infoSnackbar({ message: "Please select a customer before submitting", duration: 5000 });
      setSubmitted(false);
      return;
    }

    setIsSubmitted("pending");
    setIsBlocking(false);

    const payload = {
      paid_amount,
      balance: change,
      payment_type: 1,
      payment_method: +paytype,
      bill_details: rows.map(row => ({
        invoicedetails_id: row?.invoicedetails_id ?? row?.id,
        product_id: row?.product_id,
        quantity: row?.product_quantity,
        rate: row?.product_rate,
        discount: row?.discount ?? 0,
        discount_rate: row?.discount_rate ?? 0,
        discount_amount: row?.discount_amount ?? 0,
        total_price: row?.total_price ?? 0,
        batch_id: row?.batch_id,
        expiry_information: row?.expiry_information ?? null,
        batch_details_id:row?.batch_details_id??null,
      })),
      invoice_date,
    };

    axios.post(`${config.epharmUrl}/Cinvoice/cashier/pending-sales/${invoice_number}/save`, payload)
      .then(response => {
        if (!isMounted.current) return;
        const data = response.data ?? {};
        const invoiceNo = data.invoice_no ?? "";
        const recep_id = data.receipt?.receipt_no ?? "";
        const cus_id = data.customer_id ?? customer_id;

        if (recep_id) {
          SetReceipt_no(recep_id);
          retrieveReceiptDetails({ receipt_number: recep_id, customer_id: cus_id });
        }

        actions.snackbarActions.successSnackbar(`Receipt ${recep_id} saved successfully!`);
        setIsSubmitted("resolved");
        setSubmitted(false);

        // if (approval_status.read) {
        //   const audio = new Audio('/audio/happy-bell-alert.mp3');
        //   audio.play();
        // }

        setRows(initialState);
        // setCustomer({ customer_name: "Walk-in Customer", customer_id });
        if (saletype === "retail" ) {
          setCustomer({ customer_name: "Walk-in Customer", customer_id: "1" });
        } else {
          // keep existing customer
          setCustomer(customer); // or just skip this line
        }
        
        setTotals({
          grand_total_price: 0,
          n_total: 0,
          change: 0,
          due_amount: 0,
          paid_amount: "",
          previous_amount: 0,
          total_discount_amount: 0
        });
        setCustomerDetails({ credit_limit: 0 });
        setInvoiceId(invoiceNo);
      }).catch(error => {
        if (!isMounted.current) return;
        errorMessages(error, null, actions);
        setIsSubmitted("rejected");
        setSubmitted(false);
      });
  };



  const validateInvoice = ({ rows, customer_id, invoice_date, totals }) => {

    for (let idx = 0; idx < rows.length; idx++) {
      const item = rows[idx];
  
      if (!item.product_name || !item.batch_id || !item.product_quantity) {
        // actions.snackbarActions.errorSnackbar(`Row ${idx + 1} is incomplete.`);
        return { valid: false,message:`Row ${idx + 1} is incomplete.`};
      }
  
      if (item.isPriceLower) {
        // actions.snackbarActions.errorSnackbar(`Row ${idx + 1}: price cannot be lower than original.`);
        return { valid:false,message:`Row ${idx + 1}: for product ${item.product_name} So the price cannot be lower than original Price.`};
      }
      if (item.isError ) {
        // actions.snackbarActions.errorSnackbar(`Row ${idx + 1}: price cannot be lower than original.`);
        return { valid:false,message:`Row ${idx + 1}: for product ${item.product_name} So the Quantity cannot be lower .`};
      }  
      if (item.isDiscountable) {
        // actions.snackbarActions.errorSnackbar(`Row ${idx + 1}: discount cannot exceed rate.`);
        return { valid:false,message:`Row ${idx + 1}: for product ${item.product_name} So the discount cannot exceed rate.`};
      }
    }
    // Validate rows
    const allRowsValid = rows.every(
      item => item.batch_id && item.product_name && item.product_quantity 
    );
    if (!allRowsValid) {
      return { valid: false, message: "Please ensure all products have batch, name, quantity and valid discount" };
    }
  
    // Validate customer
    if (!customer_id) {
      return { valid: false, message: "Please select a customer before submitting" };
    }
  
    // Validate invoice date
    if (!invoice_date) {
      return { valid: false, message: "Please select a valid  Date" };
    }
  
    // Optionally: check totals
    if (totals.n_total <= 0) {
      return { valid: false, message: "Total amount should be greater than zero" };
    }
  
    return { valid: true };
  };
  
  const saveDispensarInvoice = (event) => {
    if (event) event.preventDefault();
    setSubmitted(true);

    const { paid_amount, n_total } = totals;
    const { customer_id } = customer;
    const { invoice_date } = state;

    const allRowsValid = rows.every(item => item.batch_id && item.product_name && item.product_quantity && !item.isDiscountable);
    if (!allRowsValid) {
      actions.snackbarActions.infoSnackbar({ message: "Please ensure all products have batch, name, quantity and valid discount", duration: 5000 });
      setSubmitted(false);
      return;
    }
    const validation = validateInvoice({ rows, customer_id, invoice_date: state.invoice_date, totals });

    if (!validation.valid) {
      actions.snackbarActions.infoSnackbar({ message: validation.message, duration: 5000 });
      setSubmitted(false);
      return;
    }

    // if (!validateCurrentDate(invoice_date)) {
    //   actions.snackbarActions.infoSnackbar({ message: "Please select a valid invoice date", duration: 5000 });
    //   setSubmitted(false);
    //   return;
    // }

    if (!customer_id) {
      actions.snackbarActions.infoSnackbar({ message: "Please select a customer before submitting", duration: 5000 });
      setSubmitted(false);
      return;
    }

    setIsSubmitted("pending");
    setIsBlocking(false);

    const payload = {
      payment_type: 1,
      payment_method: +paytype,
      customer_id,
      total_amount: n_total,
      amount_paid: paid_amount,
      bill_details: rows.map(row => ({
        product_id: row.product_id,
        quantity: row.product_quantity,
        rate: row.product_rate,
        discount: row.discount ?? 0,
        discount_rate: row.discount_rate ?? 0,
        total_price: row.total_price ?? 0,
        // batch_details_id: row.batch_details_id, // new
        batch_id: row.batch_id,
        batch_info: row.batch_info,
        batch_details_id:row.batch_id.batch_details_id??row.batch_details_id,
        original_rate: row.original_rate,
        total_stock: row.total_stock,
        expiry_information: row.expiry_information ?? null,
      })),
      invoice_date,
      is_wholesale: saletype === "wholesale",
    };

    axios.post(`${config.epharmUrl}/Cinvoice/create/dispensar/invoice`, payload)
      .then(response => {
        if (!isMounted.current) return;
        const data = response.data?.data ?? {};
        actions.snackbarActions.successSnackbar(`Invoice ${data.invoice_no ?? ""} saved successfully!`);
        setIsSubmitted("resolved");
        setSubmitted(false);

        setRows(initialState);
        // setCustomer({ customer_name: "Walk-in Customer", customer_id });
        if (saletype === "retail") {
          setCustomer({ customer_name: "Walk-in Customer", customer_id: "1" });
        } else {
          // keep existing customer
          setCustomer(customer); // or just skip this line
        }
        
        setTotals({
          grand_total_price: 0,
          n_total: 0,
          change: 0,
          due_amount: 0,
          paid_amount: "",
          previous_amount: 0,
          total_discount_amount: 0
        });
        setCustomerDetails({ credit_limit: 0 });
        setInvoiceId(data.invoice_no ?? "");
      })
      .catch(error => {
        if (!isMounted.current) return;
        errorMessages(error, null, actions);
        setIsSubmitted("rejected");
        setSubmitted(false);
      });
  };

  const handleCloseSnackbar = () => actions.snackbarActions.hideSnackBar();

  const handleViewReceiptS = () => history.push(`/receipt_print/${customer_id}/${receipt_no}`);
  const handleViewReceipt_cash = () => history.push(`/receipt_print/${customer_id}/${receipt_no}`);
  const handleViewReceipt = () => history.push(`/receipt_print_new/${customer_id}/${invoice_id}`);

  const isPending = isSubmitted === "pending";
  const isResolved = isSubmitted === "resolved";
  const isRejected = isSubmitted === "rejected";

  const addedState = { ...stateVariables, payTypes };

  return {
    submitted,
    stateFunctions,
    stateVariables: addedState,
    openDialog,
    invoice_id,
    isPending,
    isResolved,
    isRejected,
    handleCloseDialog,
    handleSaveReceipt,
    handleCloseSnackbar,
    handleViewReceipt,
    saveDispensarInvoice,
    handleCashierSaveReceipt,
    handleViewReceiptS,
    receiptData,
    handleViewReceipt_cash,
  };
};
